import { ILogger } from '@qest/logger-utils'

const seznamMapErrorMessages = [
  'mapyczDomain of undefined',
  'reading mapyczDomain',
  'SMap._ is undefined',
  'evaluating SMap.CONFIG.mapyczDomain',
  'evaluating window.SMap.Coords',
  'SMap._ is not a function',
  'window.SMap.Coords',
  'SMap.CONFIG is undefined',
]

export const isSeznamMapError = (msg: string | object | Error): boolean => {
  const msgWithoutQuotes = msg.toString().replace(/["']/g, '')
  return seznamMapErrorMessages.some((m) => msgWithoutQuotes.includes(m))
}

export const logWishListError = (
  error: string | object | Error,
  scope: string,
  logger: ILogger
): void => {
  let msg = `${error}`

  if (/^Wish with ID (.+) not found$/i.test(msg.trim())) {
    msg = 'Wish not found'
  }

  logger.error(`${scope} : ${msg}`, error)
}
